import { useCallback } from 'react';
import { useRouter } from '~/utils/navigation';
import useContextualPathTransformer from '../../../hooks/use-contextual-path-transformer.js';
import { ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION } from './constants/we-spin-route-constants.js';

const useOpenCreateEvent = () => {
	const router = useRouter();

	const transformPath = useContextualPathTransformer();

	const openCreateEvent = useCallback(() => {
		localStorage.setItem('profile.isPrivate', 'true');
		router.replace(transformPath(ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION));
	}, [router, transformPath]);

	return openCreateEvent;
};

export default useOpenCreateEvent;
